module.exports = __webpack_public_path__ + "static/media/fly0235.9a97737f.webp";